"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _Form = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Form"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _validations = require("./validations");
var _AddPageButton = _interopRequireDefault(require("../AddPageButton"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "error": "CreatePage__error__3ZtsP",
  "form": "CreatePage__form__31hYB",
  "text-field": "CreatePage__text-field__2yJAl",
  "textField": "CreatePage__text-field__2yJAl"
}; 
require('./CreatePage.css');
var CreatePage = /*#__PURE__*/function (_React$PureComponent) {
  function CreatePage() {
    var _this;
    (0, _classCallCheck2.default)(this, CreatePage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CreatePage, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      isCreating: false,
      form: {
        pageName: ''
      }
    });
    (0, _defineProperty2.default)(_this, "handleTextFieldKeyDown", function (event) {
      if (event.key === 'Escape') {
        _this.leaveCreatingState();
      }
    });
    (0, _defineProperty2.default)(_this, "handleNewPageClick", function () {
      _this.setState({
        isCreating: true
      });
    });
    (0, _defineProperty2.default)(_this, "savePageName", function () {
      // eslint-disable-next-line react/destructuring-assignment
      var pageName = _this.state.form.pageName.trim();
      var _this$props = _this.props,
        pages = _this$props.pages,
        onCreatePage = _this$props.onCreatePage;
      if ((0, _validations.isValidPageName)(pages, pageName)) {
        onCreatePage(pageName);
        _this.leaveCreatingState();
      } else if (!pageName) {
        _this.leaveCreatingState();
      }
    });
    (0, _defineProperty2.default)(_this, "leaveCreatingState", function () {
      _this.setState({
        isCreating: false,
        form: {
          pageName: ''
        }
      });
    });
    (0, _defineProperty2.default)(_this, "handleFormChange", function (_ref) {
      var target = _ref.target,
        value = _ref.value;
      _this.setState(function (state) {
        return {
          form: _objectSpread(_objectSpread({}, state.form), {}, (0, _defineProperty2.default)({}, target, value[target]))
        };
      });
    });
    return _this;
  }
  (0, _inherits2.default)(CreatePage, _React$PureComponent);
  return (0, _createClass2.default)(CreatePage, [{
    key: "getAddNewPageButton",
    value: function getAddNewPageButton() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$disabled = _ref2.disabled,
        disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
        _ref2$label = _ref2.label,
        label = _ref2$label === void 0 ? '' : _ref2$label;
      var isDraft = this.props.isDraft;
      var isCreating = this.state.isCreating;
      if (isCreating && !isDraft) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_AddPageButton.default, {
        ariaLabel: label,
        disabled: disabled,
        onClick: this.handleNewPageClick
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        isCreating = _this$state.isCreating,
        form = _this$state.form;
      var _this$props2 = this.props,
        pages = _this$props2.pages,
        tooltipOffset = _this$props2.tooltipOffset;
      var limitReached = pages && pages.length >= _validations.MAX_PAGE_COUNT;
      var inputValidations = (0, _validations.getInputValidations)(pages);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isCreating ? /*#__PURE__*/_react.default.createElement(_Form.default, {
        className: styles.form,
        onChange: this.handleFormChange,
        onSubmit: this.savePageName,
        onBlur: this.savePageName,
        onKeyDown: this.handleTextFieldKeyDown,
        value: form
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        className: styles.textField,
        testId: "add-new-page-name",
        name: "pageName",
        type: "text",
        maxLength: _validations.MAX_PAGE_NAME_LENGTH,
        placeholder: "New page name",
        validate: inputValidations,
        autoFocus: true
      })) : null, !isCreating ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, limitReached ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        position: "top",
        offset: tooltipOffset,
        content: "Page limit has been reached",
        testId: "limit-reached-tooltip"
      }, this.getAddNewPageButton({
        disabled: true,
        label: 'Page limit has been reached'
      })) : this.getAddNewPageButton()) : null);
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(CreatePage, "defaultProps", {
  tooltipOffset: [0, 0],
  isDraft: false
});
var _default = exports.default = CreatePage;
//# sourceMappingURL=CreatePage.js.map